// extracted by mini-css-extract-plugin
export default {"Swiper":"Slider_Swiper__fftRU","Img":"Slider_Img__EKnZq","PrevButton":"Slider_PrevButton__0ITqe","NextButton":"Slider_NextButton__mvfS-"};